


export const VideoAnalytics = () => {

    return <h1>Video Analytics</h1>
}